var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"surf-layout",class:_vm.wrapperClasses},[_c('div',{staticClass:"surf-layout__section",class:_vm.sectionClasses},[_vm._t("content")],2),_vm._t("append")],2)}
var staticRenderFns = []

export { render, staticRenderFns }